<!-- =========================================================================================
    File Name: VxSidebar.vue
    Description: Sidebar Component
    Component Name: VxSidebar
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="parentx">
    <vs-sidebar
      ref="mainSidebar"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      default-index="-1"
      class="sidebarx main-menu-sidebar items-no-padding"
      v-model="isSidebarActive"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
    >
      <!-- <div
        style="background: transparent;position:absolute;left:0;right:0;top:0:bottom: 0;height: 100%;z-index:200000"
      >
        {{ company_default.active }}
      </div> -->
      <div @mouseenter="sidebarMouseEntered" @mouseleave="sidebarMouseLeave">
        <div
          class="header-sidebar flex items-end justify-between"
          slot="header"
        >
          <div class="logo flex items-center">
            <img src="@/assets/logo-ico.png" alt="logo" width="50" />

            <span
              style="padding-left: 0.3em; font-size: 18px !important"
              class="logo-text"
              v-show="isMouseEnter || !reduce"
              v-if="user"
              >{{
                user ? "FactureCR" : "FactureCR" | truncateText(0, 15)
              }}</span
            >
          </div>
          <div>
            <template v-if="showCloseButton">
              <feather-icon
                icon="XIcon"
                class="m-0 cursor-pointer"
                @click="$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false)"
              ></feather-icon>
            </template>
            <template v-else-if="!showCloseButton && !sidebarItemsMin">
              <feather-icon
                icon="DiscIcon"
                class="mr-0 cursor-pointer"
                svg-classes="stroke-current"
                v-show="!reduce"
                @click="toggleReduce(true)"
                id="btnSidebarToggler"
              ></feather-icon>
              <feather-icon
                icon="CircleIcon"
                class="mr-0 cursor-pointer"
                svg-classes="stroke-current"
                v-show="reduce"
                @click="toggleReduce(false)"
                id="btnSidebarToggler"
              ></feather-icon>
            </template>
          </div>
        </div>

        <div class="shadow-bottom" v-show="showShadowBottom"></div>

        <!-- exchage rate -->
        <div style="width: 100%; padding-left: 40px; font-weight: bold">
          <p class="text-primary">
            <i class="fa fa-chart-line"></i>
            TCO: 1$ = ₡ {{ exchange_rate }}
          </p>
        </div>

        <VuePerfectScrollbar
          ref="mainSidebarPs"
          class="scroll-area--main-sidebar pt-2"
          :settings="settings"
          @ps-scroll-y="psSectionScroll"
        >
          <template v-for="(sidebarItem, index) in itemsSidebarPermission">
            <!-- GROUP ITEM HEADER -->
            <span
              style="margin: 0; padding: 10px"
              :key="`header-${index}`"
              v-if="sidebarItem.header && !sidebarItemsMin"
              class="navigation-header truncate"
              >{{ $t(sidebarItem.i18n) || sidebarItem.header }}</span
            >
            <template v-else-if="!sidebarItem.header">
              <!-- IF IT'S SINGLE ITEM -->
              <vx-sidebar-item
                ref="sidebarLink"
                :key="`sidebarItem-${index}`"
                v-if="!sidebarItem.submenu"
                :index="index"
                :to="sidebarItem.slug != 'external' ? sidebarItem.url : ''"
                :href="sidebarItem.slug == 'external' ? sidebarItem.url : ''"
                :icon="sidebarItem.icon"
                :target="sidebarItem.target"
                :isDisabled="
                  !company_default.active &&
                    user.rol !== 'admin' &&
                    sidebarItem.name !== 'Mis compañias'
                "
              >
                <span v-show="!sidebarItemsMin" class="truncate">{{
                  $t(sidebarItem.i18n) || sidebarItem.name
                }}</span>
                <vs-chip
                  class="ml-auto"
                  :color="sidebarItem.tagColor"
                  v-if="sidebarItem.tag && (isMouseEnter || !reduce)"
                  >{{ sidebarItem.tag }}</vs-chip
                >

                <span
                  class="new-item"
                  v-if="sidebarItem.new_item"
                  @click.prevent="newItem(sidebarItem)"
                >
                  <a :href="sidebarItem.new_item" class="text-success">
                    <i class="fa fa-plus"></i>
                  </a>
                </span>
              </vx-sidebar-item>

              <!-- IF HAVE SUBMENU / DROPDOWN -->
              <template v-else>
                <vx-sidebar-group
                  ref="sidebarGrp"
                  :key="`group-${index}`"
                  :openHover="openGroupHover"
                  :group="sidebarItem"
                  :groupIndex="index"
                  :open="isGroupActive(sidebarItem)"
                  v-if="
                    (sidebarItem.name == 'Administrador' &&
                      user.rol == 'admin') ||
                      sidebarItem.name == 'Reportes' ||
                      sidebarItem.name == 'Simplificado'
                  "
                ></vx-sidebar-group>
              </template>
            </template>
          </template>
          <div style="height: 100px"></div>
        </VuePerfectScrollbar>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VxSidebarGroup from "./VxSidebarGroup.vue";
import VxSidebarItem from "./VxSidebarItem.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "vx-sidebar",
  props: {
    sidebarItems: {
      type: Array,
      required: true
    },
    title: {
      type: String
    },
    logo: {
      type: String
    },
    parent: {
      type: String
    },
    openGroupHover: {
      type: Boolean,
      default: false
    },
    reduceNotRebound: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    clickNotClose: false, // disable close sidebar on outside click
    reduce: false, // determines if sidebar is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    isMouseEnter: false,
    settings: {
      // perfectscrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true
    },
    windowWidth: window.innerWidth, //width of windows
    showShadowBottom: false
  }),
  computed: {
    ...mapState(["user", "exchange_rate", "company_default"]),
    itemsSidebarPermission() {
      if (
        this.company_default.permission == 1 ||
        this.company_default.permission == 4 ||
        this.company_default.permission == 3 ||
        this.company_default.permission == 5
      ) {
        if (this.company_default.permission == 3) {
          let firts_items = this.sidebarItems.slice(0, 2);
          let last_items = this.sidebarItems.slice(2, this.sidebarItems.length);
          firts_items.push({
            url: "/students",
            name: "Estudiantes",
            slug: "/students",
            icon: "UsersIcon",
            i18n: "Estudiantes"
            //new_item: 'new-student'
          });

          return firts_items.concat(last_items);
        }

        //If plan is API
        if (this.company_default.permission == 5) {
          let firts_items = this.sidebarItems.filter(
            i =>
              i.url != "/items" &&
              i.url != "/quotations" &&
              i.url != "/recurrings" &&
              i.url != "/payments" &&
              i.name != "Simplificado"
          );

          firts_items = firts_items.map(i => {
            if (
              i.url == "/invoices" ||
              i.url == "/tickets" ||
              i.url == "/clients" ||
              i.url == "/items" ||
              i.url == "/message-receptors"
            ) {
              return { ...i, new_item: null };
            }
            return i;
          });

          return firts_items;
        }
        //If company no hacienda
        if (this.company_default.no_hacienda) {
          this.sidebarItems = this.sidebarItems.filter(
            i => i.url != "/message-receptors" && i.name != "Simplificado"
          );
        }

        return this.sidebarItems;
      } else {
        return [
          {
            url: "/dashboard",
            name: "Dashboard",
            slug: "dashboard",
            icon: "HomeIcon",
            i18n: "Dashboard"
          },
          {
            url: "/message-receptors",
            name: "Recepción Documentos",
            slug: "/message-receptors",
            icon: "FileTextIcon",
            i18n: "Recepción Documentos",
            new_item: "new-message-receptor"
          },
          {
            url: null,
            name: "Reportes",
            slug: "reports",
            icon: "ActivityIcon",
            i18n: "Reportes",
            submenu: [
              {
                url: "/report-expenses",
                name: "Reporte gastos",
                slug: "/report-expenses",
                i18n: "Reporte gastos"
              }
            ]
          }
        ];
      }
    },
    isSidebarActive: {
      get() {
        return this.$store.state.isSidebarActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", val);
      }
    },
    reduceSidebar() {
      return Boolean(this.reduce && this.reduceButton);
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      }
    },
    sidebarItemsMin() {
      return this.$store.state.sidebarItemsMin;
    },
    isGroupActive() {
      return sidebarItem => {
        const path = this.$route.fullPath;
        let open = false;
        let func = function(sidebarItem) {
          if (sidebarItem.submenu) {
            sidebarItem.submenu.forEach(item => {
              if (path == item.url) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(sidebarItem);
        return open;
      };
    }
  },
  watch: {
    reduce(val) {
      if (val == true) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.dispatch("updateSidebarWidth", "default");
      }

      setTimeout(function() {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    reduceButton() {
      this.setSidebarWidth();
    },
    $route() {
      if (this.isSidebarActive && this.showCloseButton)
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
    }
  },
  methods: {
    ...mapActions(["getExchangeRate"]),

    newItem(item) {
      this.$router.push(item.new_item);
    },
    sidebarMouseEntered() {
      if (this.reduce) this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", false);
      this.isMouseEnter = true;
    },
    sidebarMouseLeave() {
      if (this.reduce) {
        this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", true);
      }
      this.isMouseEnter = false;
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setSidebarWidth();
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        if (this.windowWidth < 992)
          this.$store.commit("UPDATE_WINDOW_BREAKPOINT", "md");
        else this.$store.commit("UPDATE_WINDOW_BREAKPOINT", "lg");

        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        if (this.reduceButton) this.reduce = false;
        // this.reduceButton = false;
        this.showCloseButton = true;
        this.clickNotClose = false;
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
        this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", false);
      } else {
        this.$store.commit("UPDATE_WINDOW_BREAKPOINT", "xl");
        if (this.reduceButton) this.reduce = true;
        else this.reduce = false;

        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
        if (this.reduceButton && !this.isMouseEnter)
          this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", true);
        else this.$store.commit("UPDATE_SIDEBAR_ITEMS_MIN", false);

        this.clickNotClose = true;
        this.showCloseButton = false;
        if (this.reduceSidebar)
          this.$store.dispatch("updateSidebarWidth", "reduced");
        else this.$store.dispatch("updateSidebarWidth", "default");
      }
    },
    psSectionScroll() {
      if (this.$refs.mainSidebarPs.$el.scrollTop > 0)
        this.showShadowBottom = true;
      else this.showShadowBottom = false;
    }
  },
  components: {
    VxSidebarGroup,
    VxSidebarItem,
    VuePerfectScrollbar
  },
  created() {
    this.getExchangeRate();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.setSidebarWidth();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/components/vxSidebar.scss";

.new-item {
  position: absolute;
  right: 15px;
  display: none;
  z-index: 200;
  font-weight: bold;
}

.vs-sidebar--item:hover .new-item {
  display: block;
}

.logo-side {
  width: 50px;
  height: 50px;
}

.logo-side path {
  fill: #25999f;
}
</style>
